<template>
  <div>
    <div class="card"
    v-loading="loading"
    element-loading-text="PSA-Suche läuft..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.7)">
      <div class="card-header">
        <div class="row">
          <div class="col-sm-9">
            <h5 class="card-title">PSA-Suche</h5>
          </div>
        </div>
      </div>
      <div class="card-body row justify-content-center">
        <div class="col-sm-6">
          <h6 style="text-align: center;"><b>Serien-Nr., Eigene Nr. oder Chargen-Nr. eingeben oder RFID/NFC-Chip scannen.</b></h6>
          <el-input
            placeholder="Serien-Nr., Eigene Nr. oder Chargen-Nr. eingeben oder scannen"
            v-model="searchTerm"
            prefix-icon="el-icon-search"
            clearable
            @change="findPsa"
            class="mb-3"
            id="searchbox">
          </el-input>
          <el-alert
            title="Es konnte kein eindeutiges Ergebnis gefunden werden."
            type="warning"
            effect="dark"
            show-icon
            center
            v-if="multipleResults == true">
          </el-alert>
          <el-alert
            title="Es konnte keine PSA mit dieser Serien-Nr., Eigenen Nr. oder Chargen-Nr. gefunden werden."
            type="warning"
            effect="dark"
            show-icon
            center
            v-if="noResults == true">
          </el-alert>
          <p-button type="success" @click="findPsa()" block size="lg" class="mt-3" :disabled="searchTerm == ''">Suchen</p-button>

          <img src="/static/img/rfid-icon.png" alt="RFID" class="img-fluid mx-auto d-block mt-4 mb-2" width="200px" >
        </div>
      </div>
    </div>

    <modal :show.sync="multipleResults" headerClasses="justify-content-center" data-backdrop="static">
      <h5 slot="header" class="title mb-0">Suchergebnisse</h5>
      <div class="row">
        <div class="col">
          <p>Es wurden mehrere PSA mit der eingegebenen Serien-Nr., eigenen Nr. oder Chargen-Nr. gefunden. Bitte das gewünschte Element aus der Liste auswählen.</p><p>Es werden maximal 10 Ergebnisse angezeigt.</p>
          <el-table
            :data="searchResults"
            style="width: 100%;"
            height="400"
            row-key="id"
            @row-click="showDetailsMultiple">
            <el-table-column prop="SerialNumber" label="Serien-Nr." min-width="110"></el-table-column>
            <el-table-column prop="psaOwnId" label="Eigene Nr." min-width="110"></el-table-column>
            <el-table-column prop="psaBatchNumber" label="Chargen-Nr." min-width="110"></el-table-column>
            <el-table-column prop="psaManufacturer" label="Hersteller" min-width="120"></el-table-column>
            <el-table-column prop="psaItem" label="Artikel"></el-table-column>
          </el-table>
        </div>
      </div>

    </modal>
  </div>
</template>
<script>
import Vue from "vue";
import { db } from "../../../../firebaseDb";
import { Input, Loading, MessageBox} from "element-ui";
import { Modal } from "src/components/UIComponents";
import moment from "moment-timezone";
import router from "../../../../main";
import store from "../../../../store";
Vue.use(Loading);

export default {
  components: {
    [Input.name]: Input,
    Modal,
    MessageBox
  },

  data() {
    return {
      loading: false,
      searchTerm: "",
      multipleResults: false,
      noResults: false,
      searchResults: [],
      psaRole: store.getters.psaRole,
    };
  },
  created() {
    if(store.getters.psaRole == "0") {
      MessageBox.alert(
        "Zugriff verweigert.",
        {
          confirmButtonText: "OK",
          type: "error",
          callback: (action) => {
            router.push({ name: 'Overview' })
          },
        }
      );
    } 
    moment.locale("de");
  },
  mounted() {
    document.getElementById("searchbox").select();
  },
  methods: {
    showDetails(docId) {
      if (docId) {
        router.push({ name: "PsaDetails", params: { psaId: docId } });
      }
    },
    showDetailsMultiple(row) {
      if (row.id) {
        router.push({ name: "PsaDetails", params: { psaId: row.id } });
      }
    },
    findPsa() {
      this.loading = true;
      this.multipleResults = false;
      this.noResults = false;

      const psaRef = db.collection("psa");
      // Search by SerialNumber, OwnId or BatchNumber
      // combine result objects into one
      const term = this.searchTerm.trim();
      if (term === "") {
        this.loading = false;
        return;
      }
      const endCode = term + '\uf8ff';

      const serialNumberQuery = psaRef.where("SerialNumber", ">=", term).where("SerialNumber", "<", endCode).limit(10);
      const ownIdQuery = psaRef.where("OwnId", ">=", term).where("OwnId", "<", endCode).limit(10);
      const batchNumberQuery = psaRef.where("BatchNumber", ">=", term).where("BatchNumber", "<", endCode).limit(10);

      // Firestore range queries are type-strict: if a PSA has OwnId stored as a
      // number (legacy entries / direct imports) the string-based prefix query
      // above will not return it. Add a numeric equality fallback when the term
      // is a plain integer so those records are still found.
      const queries = [serialNumberQuery.get(), ownIdQuery.get(), batchNumberQuery.get()];
      if (/^\d+$/.test(term)) {
        const numericTerm = parseInt(term, 10);
        if (Number.isFinite(numericTerm)) {
          queries.push(psaRef.where("OwnId", "==", numericTerm).limit(10).get());
          queries.push(psaRef.where("SerialNumber", "==", numericTerm).limit(10).get());
          queries.push(psaRef.where("BatchNumber", "==", numericTerm).limit(10).get());
        }
      }

      Promise.all(queries).then((results) => {
        this.searchResults = [];
        results.forEach((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            // Avoid duplicates
            if (!this.searchResults.find(d => d.id === doc.id)) {
              this.searchResults.push({
                id: doc.id,
                psaOwnId: doc.data().OwnId,
                psaBatchNumber: doc.data().BatchNumber || "",
                SerialNumber: doc.data().SerialNumber,
                psaManufacturer: doc.data().Manufacturer,
                psaItem: doc.data().Item,
                psaStatus: doc.data().Status,
              });
            }
          });
        });

        if (this.searchResults.length > 1) {
          this.multipleResults = true;
          this.loading = false;
        } else if (this.searchResults.length === 0) {
          this.noResults = true;
          this.loading = false;
        } else if (this.searchResults.length === 1) {
          this.noResults = false;
          this.multipleResults = false;
          this.loading = false;
          this.searchTerm = "";
          this.showDetails(this.searchResults[0].id);
        }
      }).catch((error) => {
        console.error("Error searching PSA:", error);
        this.loading = false;
      });
    }
  },
};
</script>
<style>

</style>
